<script>
    import {onMount } from 'svelte'    
    import createRouter from 'router5'
    import browserPlugin from 'router5-plugin-browser'    
    import  routerManager  from './router.js'
    
    
    

    export let routes

    export let defaultRoute

    export let middlewares = undefined

    export let header;

    export let footer;

    export let name = 'default';

   

    let comp;

    let params = {};


    onMount(()=>{
        
        const router = createRouter(routes, {
            defaultRoute
        })
        router.usePlugin(browserPlugin({ useHash: true, hashPrefix: '' }))
        
        if(middlewares != undefined){
            router.useMiddleware(...middlewares)
        }
        router.start((err, s) => {
            if(!err){ comp  = routes.find(r=> r.name == s.name).component }            
        })
        params.router = router
        router.subscribe((e)=>{                        
            comp  = routes.find(r=> r.name == e.route.name).component
            params.params = e.route.params
           

            
        })
        routerManager.addRouter(name,router)
        
    })
    
</script>
{#if comp }    
    <svelte:component this={header}  />    
    <svelte:component this={comp} />    
    <svelte:component this={footer}   />    
{:else}
    <h3 class="text-5xl text-center p-10">404</h3>
{/if}    
